import React from 'react'
import './AboutMe.css'

const AboutMe = () => {
  return (
    <div className='sobremi'>
        <h2>Sobre mi</h2>
        <div className="aboutme_text">
            <p>Soy de Rosario, Argentina. Me recibí como Técnico Superior en Marketing, y aparte de mis conocimientos como Marketinero, sume grandes bases de programación, asi realizando cursos de Desarrollo fullStack. Cuento con experiencia realizando sitios web para empresas en Rosario y cuento con un buen nivel de Inglés.</p>
        </div>
    </div>
  )
}

export default AboutMe